import { render, staticRenderFns } from "./TypeInput.vue?vue&type=template&id=3e5a46de&"
import script from "./TypeInput.vue?vue&type=script&lang=js&"
export * from "./TypeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAlert,VSelect})
